import axios from 'axios';
import config from '../../config';

import tokenApi from './tokenApi';

const schoolquotaInstance = axios.create({
	baseURL: config.api,
    headers: {
		'Content-Type': 'application/json'
	}
});

class SchoolQuotaApi {  

	static SchoolQuotaInsert(payload) {
		schoolquotaInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();

		return schoolquotaInstance.post('/schoolquota', payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static SchoolQuotaUpdate(payload, id) {
		schoolquotaInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();

		return schoolquotaInstance.patch(`/schoolquota/${id}`, payload)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static SchoolQuotaList() {
		schoolquotaInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		
		return schoolquotaInstance.get('/schoolquota?showMore=true')
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

	static SchoolQuotaDelete(id) {
		schoolquotaInstance.defaults.headers.common['Authorization'] = tokenApi.GetToken();
		
		return schoolquotaInstance.delete(`/schoolquota/${id}`)
		.then(function (response) {
			return response.data;
		})
		.catch(function (error) {
			throw(error);
		});
	}

}

export default SchoolQuotaApi; 


